import React from 'react'
import { Link } from 'react-router-dom';
import './Error.css';

function ErrorPage() {
    return (
        <>
            <main>
                <article id="fullpage">
                    {/* #overview */}
                    <section className="overview section" id="overview" aria-label="overview">
                        <div className="container" style={{ marginTop: "30px" }}>
                            <div id="notfound">
                                <div class="notfound">
                                    <div class="notfound-404">
                                        <h1>Oops!</h1>
                                    </div>
                                    <h2>404 - Page not found</h2>
                                    <p>The page you are looking for might have been removed had its name changed or is temporarily unavailable.</p>
                                    <Link to="/" className='btn btn-primary'>Go To Homepage</Link>
                                </div>
                            </div>

                        </div>
                    </section>
                </article>
            </main>
        </>
    )
}

export default ErrorPage